import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BreadcrumbsComponentDef } from '@df/ui/common/breadcrumbs.component.def';
import { HrefComponent } from '@df/ui/common/href/href.component';

/**
 * Breadcrumbs component
 *
 * ## usage
 *
 * <breadcrumbs></breadcrumbs>
 */
@Component({
    standalone: true,
    imports: [HrefComponent, NgClass],
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent extends BreadcrumbsComponentDef {}
